<template>
    <div
        class="image-container text-center mb-5"
        :class="!invoice.seller_logo_url && isEditing ? 'no-image' : ''"
    >
        <img
            v-if="invoice.seller_logo_url"
            :src="baseUrl + invoice.seller_logo_url"
            alt="avatar"
        />
    </div>
</template>
<script>
export default {
    name: "InvoiceSellerAvatar",
    components: {},
    props: {
        isEditing: {
            type: Boolean,
            default: false
        },
        invoice: {
            type: Object,
            required: true
        },
        translations: {
            type: Object,
            required: true
        }
    },
    setup() {
        const protocol = process.env.VUE_APP_PROTOCOL ? process.env.VUE_APP_PROTOCOL : "";
        const host = process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : "";
        const baseUrl = `${protocol}://${host}`;
        return {
            baseUrl
        };
    }
};
</script>

<style lang="scss" scoped>
.no-image {
    background-color: var(--v-gray-lighten3);
}
</style>
